import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './SearchBar.module.scss'
import { Button } from 'components/Button'
import { TextInput } from 'components/TextInput'
import { Flex } from 'components/Flex'

type SearchBarProps = {
  q: string
  setFilters: (q: string) => void
}

export const SearchBar: FC<SearchBarProps> = ({ q, setFilters }) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState(q)

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    setFilters(search ?? '')
  }

  return (
    <Flex justify="between" align="center" className={styles.searchBar}>
      <form onSubmit={handleSubmit} className={styles.form}>
        <TextInput
          name="globalSearch"
          label={t('project.table.filter.searchLabel')}
          value={search}
          onChange={(event) => setSearch(event.target.value)}
        />
        <Button type="submit">{t('project.table.filter.searchBtn')}</Button>
      </form>
    </Flex>
  )
}
